import categoryFilterListTemplate from './category_filter_list.template.html';

angular.module('westBerkshireEvents.categoryFilterList').component('wbCategoryFilterList', {
    templateUrl: categoryFilterListTemplate.id,
    controller: ['$scope', WbCategoryFilterListController],
    controllerAs: "$categoryFilterListCtrl",
    bindings: {
        eventGroups: '<',
        filters: '<',
        onFilterChanged: '&',
        showCompanyNames: '<'
    }
});

function WbCategoryFilterListController($scope) {
    var self = this;

    this.filterClicked = function (eventGroup) {
        self.filters.event_group = eventGroup;
        if (self.onFilterChanged) {
            self.onFilterChanged();
        }
    }

    this.clearFilter = function () {
        self.filters.event_group = null;
        if (self.onFilterChanged) {
            self.onFilterChanged();
        }
    }

    $scope.BannerFilter = function (type) {
        let groupMatch = self.eventGroups.filter(group => group.name == type)

        if (groupMatch.length) {
            // Apply the filter
            self.filters.event_group = groupMatch[0];
            if (self.onFilterChanged) {
                self.onFilterChanged();
            }
        }
    }

    $scope.$on('ApplyCategoryFilter', function (evt, data) {
        $scope.BannerFilter(data);
    });
}



// WEBPACK FOOTER //
// src/public/javascripts/category-filter-list/category_filter_list.component.js